/**
 * @generated SignedSource<<54b6fb7791c7444536fbcbc259409cb8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GLOBAL_FILTER_CONTEXT = "PROJECTS" | "PEOPLE" | "TASKS" | "TIME_REGS" | "INVOICES" | "SKILLS" | "LABELS" | "PLACEHOLDERS" | "RESOURCES" | "%future added value";
export type GLOBAL_FILTER_FIELD = "COMPANY_TASK_ID" | "NAME" | "STATUS" | "PROJECT_STATUS" | "PROJECT_GROUP_STATUS" | "PROJECT_PHASE" | "PROJECT_SPRINT" | "PROJECT_GROUP_SPRINT" | "DESCRIPTION" | "REMAINING" | "TIME_REGS" | "FORECAST" | "TASK_APPROVED" | "START_DATE" | "START_DATE_PROJECT" | "END_DATE" | "END_DATE_PROJECT" | "START_DATE_TIME_REG" | "PHASE_TIME_REG" | "END_DATE_TIME_REG" | "PROJECT_TIME_REG" | "ROLE_TIME_REG" | "TEAM_TIME_REG" | "DEPARTMENT_TIME_REG" | "INTERNAL_TIME_REG" | "TIME_OFF_TIME_REG" | "BILLABLE_TIME_REG" | "NON_PROJECT_TIME_REG" | "NON_PHASE_TIME_REG" | "NON_TASK_TIME_REG" | "NON_CLIENT_TIME_REG" | "NON_DEPARTMENT_TIME_REG" | "NON_ROLE_TIME_REG" | "NON_SPRINT_TIME_REG" | "PERSON_TIME_REG" | "CLIENT_TIME_REG" | "SPRINT_TIME_REG" | "LABEL_TIME_REG" | "TASK_TIME_REG" | "CREATED_AT" | "WITH_TIME_REG" | "WITH_TASKS" | "TASK" | "TASK_LEVEL" | "UPDATED_AT" | "SET_DONE_AT" | "ASSIGNED" | "ASSIGNED_SELF" | "OWNER" | "FOLLOWER" | "LABELS" | "PROJECT_LABELS" | "ROLE" | "PROJECT" | "PROJECT_PERSON" | "CLIENT" | "PROJECT_STAGE" | "BUG" | "BLOCKED" | "BILLABLE" | "HIGH_PRIORITY" | "STARRED" | "RECENT_TIME" | "RECENT_TASK_ACTIVITY" | "RECENT_ACTIVITY" | "PHASE_CATEGORY" | "SPRINT_CATEGORY" | "DEADLINE" | "OWN_START_DATE" | "OWN_DEADLINE" | "TEAM_MEMBER" | "TEAM" | "PERMISSION_LEVEL" | "CLIENT_GUEST_USERS" | "DEPENDENCIES" | "SUB_TASKS" | "TASK_HIERARCHY" | "DEPARTMENT" | "PERSON" | "NO_CONTACT" | "APPROVAL_STATUS" | "INTERNAL_TIME" | "TIME_OFF" | "PROJECT_FOLLOWER" | "PROJECT_OWNER" | "PROJECT_BUDGET_TYPE" | "PROJECT_DEFAULT_PERIOD_BUDGET_TYPE" | "RATE_CARD" | "CONTACT" | "INVOICED" | "SKILL" | "PRIORITY_LEVEL" | "PROJECT_GROUP" | "PROGRAM" | "FILTER_BY_TIME_REG_SETTINGS" | "BILL_TO" | "BILL_FROM" | "PROJECT_MANUAL_PROGRESS" | "RETAINER_PERIOD" | "PROJECT_WIN_CHANCE" | "CLIENT_CONTACT_CLIENT_ID" | "CLIENT_CONTACT_COMPANY_ID" | "CLIENT_CONTACT_ID" | "CLIENT_CONTACT" | "CLIENT_CONTACT_NAME" | "CLIENT_CONTACT_FIRST_NAME" | "CLIENT_CONTACT_LAST_NAME" | "CLIENT_CONTACT_EMAIL" | "CLIENT_CONTACT_STATUS" | "CLIENT_CONTACT_IS_GUEST_USER" | "PHASE" | "SPRINT" | "DELIVERABLE" | "PARENT" | "PROGRESS" | "ESTIMATE" | "CREATED" | "UPDATED" | "PROJECT_STATUS_RAG" | "PROGRESS_BUCKET" | "WIN_CHANCE_BAND" | "TOTAL_REGISTERED_HOURS" | "BILLABLE_HOURS" | "NON_BILLABLE_HOURS" | "RETAINER_OVER_UNDER" | "RETAINER_PERIOD_START" | "RETAINER_PERIOD_END" | "%future added value";
export type GLOBAL_FILTER_LOGICAL_OPERATOR = "AND" | "OR" | "%future added value";
export type GLOBAL_FILTER_OPERATOR = "IS" | "IS_NOT" | "IS_ALL" | "IS_NOT_ALL" | "CONTAINS" | "CONTAINS_NOT" | "GREATER" | "GREATER_OR_EQUAL" | "LESS" | "LESS_OR_EQUAL" | "IN" | "NOT_IN" | "ALL_IN" | "NOT_ALL_IN" | "%future added value";
export type TaskSearchQueryType = {
  filters?: ReadonlyArray<GlobalSearchFilterType | null> | null;
};
export type GlobalSearchFilterType = {
  field?: GLOBAL_FILTER_FIELD | null;
  operator?: GLOBAL_FILTER_OPERATOR | null;
  value?: ReadonlyArray<string | null> | null;
  context?: GLOBAL_FILTER_CONTEXT | null;
  filters?: ReadonlyArray<GlobalSearchFilterType | null> | null;
  logicalOperator?: GLOBAL_FILTER_LOGICAL_OPERATOR | null;
};
export type ResourceNumbersBreakdownLoaderQuery_Query$variables = {
  startYear?: number | null;
  startMonth?: number | null;
  startDay?: number | null;
  endYear?: number | null;
  endMonth?: number | null;
  endDay?: number | null;
  personId?: string | null;
  count?: number | null;
  cursor?: string | null;
  searchQuery?: TaskSearchQueryType | null;
};
export type ResourceNumbersBreakdownLoaderQuery_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"ResourceNumbersBreakdownLoader_viewer">;
  } | null;
};
export type ResourceNumbersBreakdownLoaderQuery_Query = {
  variables: ResourceNumbersBreakdownLoaderQuery_Query$variables;
  response: ResourceNumbersBreakdownLoaderQuery_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDay"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endMonth"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endYear"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "personId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchQuery"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDay"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startMonth"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startYear"
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "ResourceNumbersBreakdownLoader"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"ResourceNumbersBreakdownLoader\")"
},
v12 = {
  "kind": "Variable",
  "name": "endDay",
  "variableName": "endDay"
},
v13 = {
  "kind": "Variable",
  "name": "endMonth",
  "variableName": "endMonth"
},
v14 = {
  "kind": "Variable",
  "name": "endYear",
  "variableName": "endYear"
},
v15 = {
  "kind": "Variable",
  "name": "searchQuery",
  "variableName": "searchQuery"
},
v16 = {
  "kind": "Variable",
  "name": "startDay",
  "variableName": "startDay"
},
v17 = {
  "kind": "Variable",
  "name": "startMonth",
  "variableName": "startMonth"
},
v18 = {
  "kind": "Variable",
  "name": "startYear",
  "variableName": "startYear"
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v20 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v15/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readOnlyAccess",
  "storageKey": null
},
v23 = [
  (v19/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyProjectGroupId",
    "storageKey": null
  },
  (v21/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "color",
    "storageKey": null
  },
  (v22/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ResourceNumbersBreakdownLoaderQuery_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              },
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "kind": "Variable",
                "name": "personId",
                "variableName": "personId"
              },
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "ResourceNumbersBreakdownLoader_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v9/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "ResourceNumbersBreakdownLoaderQuery_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "personId"
                  }
                ],
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "person",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  {
                    "alias": null,
                    "args": (v20/*: any*/),
                    "concreteType": "ResourceNumbersBreakdownTypeConnection",
                    "kind": "LinkedField",
                    "name": "resourceNumbersBreakdown",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ResourceNumbersBreakdownTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ResourceNumbersBreakdown",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "IdleTime",
                                "kind": "LinkedField",
                                "name": "idleTime",
                                "plural": false,
                                "selections": [
                                  (v19/*: any*/),
                                  (v21/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isInternalTime",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectType",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": [
                                  (v19/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "companyProjectId",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "customProjectId",
                                    "storageKey": null
                                  },
                                  (v21/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "projectColor",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "projectGroupId",
                                    "storageKey": null
                                  },
                                  (v22/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "fullAccessToProject",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Person",
                                    "kind": "LinkedField",
                                    "name": "projectOwner",
                                    "plural": false,
                                    "selections": [
                                      (v19/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "fullName",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectGroupType",
                                "kind": "LinkedField",
                                "name": "projectGroup",
                                "plural": false,
                                "selections": (v23/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ResourceNumbers",
                                "kind": "LinkedField",
                                "name": "resourceNumbers",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "actualBillableProjectMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "actualNonBillableProjectMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "actualInternalMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "actualTotalMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "actualBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "actualNonBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "actualInternalUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "actualResourceUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableProjectMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableProjectMinutesWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableProjectMinutesSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableProjectMinutesSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableProjectMinutesHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableProjectMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableProjectMinutesWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableProjectMinutesSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableProjectMinutesSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableProjectMinutesHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedInternalMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedTotalMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedTotalMinutesWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedTotalMinutesSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedTotalMinutesSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedTotalMinutesHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableUtilizationWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableUtilizationSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableUtilizationSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableUtilizationHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableUtilizationWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableUtilizationSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableUtilizationSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableUtilizationHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedInternalUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedResourceUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedResourceUtilizationWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedResourceUtilizationSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedResourceUtilizationSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedResourceUtilizationHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedInternalTimeTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedTotalTimeTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableUtilizationTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableUtilizationTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedInternalUtilizationTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedResourceUtilizationTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedTotalTimeTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableUtilizationTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableUtilizationTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedResourceUtilizationTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedTotalTimeTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableUtilizationTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableUtilizationTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedResourceUtilizationTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedTotalTimeTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableUtilizationTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableUtilizationTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedResourceUtilizationTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedTotalTimeTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableUtilizationTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableUtilizationTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedResourceUtilizationTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingTotalTimeTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableUtilizationTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableUtilizationTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingResourceUtilizationTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingTotalTimeTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableUtilizationTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableUtilizationTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingResourceUtilizationTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingTotalTimeTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableUtilizationTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableUtilizationTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingResourceUtilizationTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingTotalTimeTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableUtilizationTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableUtilizationTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingResourceUtilizationTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastTotalTimeTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableUtilizationTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableUtilizationTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastResourceUtilizationTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastTotalTimeTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableUtilizationTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableUtilizationTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastResourceUtilizationTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastTotalTimeTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableUtilizationTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableUtilizationTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastResourceUtilizationTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastTotalTimeTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableUtilizationTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableUtilizationTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastResourceUtilizationTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "billableActualVsPlan",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "billableActualVsPlanWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "billableActualVsPlanSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "billableActualVsPlanSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "billableActualVsPlanHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "nonBillableActualVsPlan",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "nonBillableActualVsPlanWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "nonBillableActualVsPlanSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "nonBillableActualVsPlanSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "nonBillableActualVsPlanHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "internalActualVsPlan",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "totalActualVsPlan",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "totalActualVsPlanWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "totalActualVsPlanSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "totalActualVsPlanSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "totalActualVsPlanHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableProjectMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableProjectMinutesWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableProjectMinutesSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableProjectMinutesSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableProjectMinutesHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableProjectMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableProjectMinutesWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableProjectMinutesSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableProjectMinutesSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableProjectMinutesHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingInternalMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingTotalMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingTotalMinutesWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingTotalMinutesSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingTotalMinutesSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingTotalMinutesHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableUtilizationWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableUtilizationSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableUtilizationSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableUtilizationHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableUtilizationWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableUtilizationSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableUtilizationSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableUtilizationHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingInternalUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingResourceUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingResourceUtilizationWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingResourceUtilizationSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingResourceUtilizationSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingResourceUtilizationHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingInternalTimeTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingTotalTimeTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableUtilizationTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingInternalUtilizationTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingResourceUtilizationTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableProjectMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableProjectMinutesWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableProjectMinutesSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableProjectMinutesSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableProjectMinutesHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableProjectMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableProjectMinutesWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableProjectMinutesSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableProjectMinutesSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableProjectMinutesHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastInternalMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastTotalMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastTotalMinutesWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastTotalMinutesSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastTotalMinutesSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastTotalMinutesHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableUtilizationWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableUtilizationSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableUtilizationSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableUtilizationHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableUtilizationWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableUtilizationSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableUtilizationSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableUtilizationHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastInternalUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastResourceUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastResourceUtilizationWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastResourceUtilizationSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastResourceUtilizationSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastResourceUtilizationHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastInternalTimeTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastTotalTimeTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableUtilizationTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableUtilizationTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastInternalUtilizationTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastResourceUtilizationTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksEstimateBillableMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksEstimateNonBillableMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksEstimateTotalMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksNonBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksResourceUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksRemainingBillableMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksRemainingNonBillableMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksRemainingTotalMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksRemainingBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksRemainingNonBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksRemainingResourceUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksOverdueRemainingBillableMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksOverdueRemainingNonBillableMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksOverdueRemainingTotalMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksForecastBillableMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksForecastNonBillableMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksForecastTotalMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksForecastBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksForecastNonBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksForecastResourceUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksBillableActualVsPlan",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksNonBillableActualVsPlan",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksTotalActualVsPlan",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableAllocationVsTask",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableAllocationVsTaskWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableAllocationVsTaskSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableAllocationVsTaskSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableAllocationVsTaskHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableAllocationVsTask",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableAllocationVsTaskWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableAllocationVsTaskSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableAllocationVsTaskSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableAllocationVsTaskHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedAllocationVsTask",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedAllocationVsTaskWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedAllocationVsTaskSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedAllocationVsTaskSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedAllocationVsTaskHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableAllocationVsTask",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableAllocationVsTaskWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableAllocationVsTaskSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableAllocationVsTaskSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableAllocationVsTaskHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableAllocationVsTask",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableAllocationVsTaskWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableAllocationVsTaskSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableAllocationVsTaskSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableAllocationVsTaskHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingAllocationVsTask",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingAllocationVsTaskWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingAllocationVsTaskSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingAllocationVsTaskSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingAllocationVsTaskHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "timeOffMinutes",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "__typename",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cursor",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endCursor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasNextPage",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v20/*: any*/),
                    "filters": [
                      "startYear",
                      "startMonth",
                      "startDay",
                      "endYear",
                      "endMonth",
                      "endDay",
                      "searchQuery"
                    ],
                    "handle": "connection",
                    "key": "ResourceNumbersBreakdown_resourceNumbersBreakdown",
                    "kind": "LinkedHandle",
                    "name": "resourceNumbersBreakdown"
                  }
                ],
                "storageKey": null
              },
              (v19/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 100000
              }
            ],
            "concreteType": "ProjectGroupTypeConnection",
            "kind": "LinkedField",
            "name": "projectGroups",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectGroupTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectGroupType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v23/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "projectGroups(first:100000)"
          },
          (v19/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "62e3dc6095ce85087d1a9b81e5d1974b",
    "id": null,
    "metadata": {},
    "name": "ResourceNumbersBreakdownLoaderQuery_Query",
    "operationKind": "query",
    "text": "query ResourceNumbersBreakdownLoaderQuery_Query(\n  $startYear: Int\n  $startMonth: Int\n  $startDay: Int\n  $endYear: Int\n  $endMonth: Int\n  $endDay: Int\n  $personId: ID\n  $count: Int\n  $cursor: String\n  $searchQuery: TaskSearchQueryType\n) {\n  viewer {\n    actualPersonId\n    component(name: \"ResourceNumbersBreakdownLoader\")\n    ...ResourceNumbersBreakdownLoader_viewer_2LpbYd\n    id\n  }\n}\n\nfragment ResourceNumbersBreakdownLoader_viewer_2LpbYd on Viewer {\n  company {\n    person(id: $personId) {\n      id\n      resourceNumbersBreakdown(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, first: $count, after: $cursor, searchQuery: $searchQuery) {\n        totalCount\n        edges {\n          node {\n            id\n            idleTime {\n              id\n              name\n              isInternalTime\n            }\n            project {\n              id\n              companyProjectId\n              customProjectId\n              name\n              projectColor\n              projectGroupId\n              readOnlyAccess\n              fullAccessToProject\n              projectOwner {\n                id\n                fullName\n              }\n            }\n            projectGroup {\n              id\n              companyProjectGroupId\n              name\n              color\n              readOnlyAccess\n            }\n            resourceNumbers {\n              actualBillableProjectMinutes\n              actualNonBillableProjectMinutes\n              actualInternalMinutes\n              actualTotalMinutes\n              actualBillableUtilization\n              actualNonBillableUtilization\n              actualInternalUtilization\n              actualResourceUtilization\n              plannedBillableProjectMinutes\n              plannedBillableProjectMinutesWin\n              plannedBillableProjectMinutesSoft\n              plannedBillableProjectMinutesSoftWin\n              plannedBillableProjectMinutesHard\n              plannedNonBillableProjectMinutes\n              plannedNonBillableProjectMinutesWin\n              plannedNonBillableProjectMinutesSoft\n              plannedNonBillableProjectMinutesSoftWin\n              plannedNonBillableProjectMinutesHard\n              plannedInternalMinutes\n              plannedTotalMinutes\n              plannedTotalMinutesWin\n              plannedTotalMinutesSoft\n              plannedTotalMinutesSoftWin\n              plannedTotalMinutesHard\n              plannedBillableUtilization\n              plannedBillableUtilizationWin\n              plannedBillableUtilizationSoft\n              plannedBillableUtilizationSoftWin\n              plannedBillableUtilizationHard\n              plannedNonBillableUtilization\n              plannedNonBillableUtilizationWin\n              plannedNonBillableUtilizationSoft\n              plannedNonBillableUtilizationSoftWin\n              plannedNonBillableUtilizationHard\n              plannedInternalUtilization\n              plannedResourceUtilization\n              plannedResourceUtilizationWin\n              plannedResourceUtilizationSoft\n              plannedResourceUtilizationSoftWin\n              plannedResourceUtilizationHard\n              plannedBillableTaskAndAllocationsCombined\n              plannedNonBillableTaskAndAllocationsCombined\n              plannedInternalTimeTaskAndAllocationsCombined\n              plannedTotalTimeTaskAndAllocationsCombined\n              plannedBillableUtilizationTaskAndAllocationsCombined\n              plannedNonBillableUtilizationTaskAndAllocationsCombined\n              plannedInternalUtilizationTaskAndAllocationsCombined\n              plannedResourceUtilizationTaskAndAllocationsCombined\n              plannedBillableTaskAndAllocationsCombinedWin\n              plannedNonBillableTaskAndAllocationsCombinedWin\n              plannedTotalTimeTaskAndAllocationsCombinedWin\n              plannedBillableUtilizationTaskAndAllocationsCombinedWin\n              plannedNonBillableUtilizationTaskAndAllocationsCombinedWin\n              plannedResourceUtilizationTaskAndAllocationsCombinedWin\n              plannedBillableTaskAndAllocationsCombinedSoft\n              plannedNonBillableTaskAndAllocationsCombinedSoft\n              plannedTotalTimeTaskAndAllocationsCombinedSoft\n              plannedBillableUtilizationTaskAndAllocationsCombinedSoft\n              plannedNonBillableUtilizationTaskAndAllocationsCombinedSoft\n              plannedResourceUtilizationTaskAndAllocationsCombinedSoft\n              plannedBillableTaskAndAllocationsCombinedSoftWin\n              plannedNonBillableTaskAndAllocationsCombinedSoftWin\n              plannedTotalTimeTaskAndAllocationsCombinedSoftWin\n              plannedBillableUtilizationTaskAndAllocationsCombinedSoftWin\n              plannedNonBillableUtilizationTaskAndAllocationsCombinedSoftWin\n              plannedResourceUtilizationTaskAndAllocationsCombinedSoftWin\n              plannedBillableTaskAndAllocationsCombinedHard\n              plannedNonBillableTaskAndAllocationsCombinedHard\n              plannedTotalTimeTaskAndAllocationsCombinedHard\n              plannedBillableUtilizationTaskAndAllocationsCombinedHard\n              plannedNonBillableUtilizationTaskAndAllocationsCombinedHard\n              plannedResourceUtilizationTaskAndAllocationsCombinedHard\n              remainingBillableTaskAndAllocationsCombinedWin\n              remainingNonBillableTaskAndAllocationsCombinedWin\n              remainingTotalTimeTaskAndAllocationsCombinedWin\n              remainingBillableUtilizationTaskAndAllocationsCombinedWin\n              remainingNonBillableUtilizationTaskAndAllocationsCombinedWin\n              remainingResourceUtilizationTaskAndAllocationsCombinedWin\n              remainingBillableTaskAndAllocationsCombinedSoft\n              remainingNonBillableTaskAndAllocationsCombinedSoft\n              remainingTotalTimeTaskAndAllocationsCombinedSoft\n              remainingBillableUtilizationTaskAndAllocationsCombinedSoft\n              remainingNonBillableUtilizationTaskAndAllocationsCombinedSoft\n              remainingResourceUtilizationTaskAndAllocationsCombinedSoft\n              remainingBillableTaskAndAllocationsCombinedSoftWin\n              remainingNonBillableTaskAndAllocationsCombinedSoftWin\n              remainingTotalTimeTaskAndAllocationsCombinedSoftWin\n              remainingBillableUtilizationTaskAndAllocationsCombinedSoftWin\n              remainingNonBillableUtilizationTaskAndAllocationsCombinedSoftWin\n              remainingResourceUtilizationTaskAndAllocationsCombinedSoftWin\n              remainingBillableTaskAndAllocationsCombinedHard\n              remainingNonBillableTaskAndAllocationsCombinedHard\n              remainingTotalTimeTaskAndAllocationsCombinedHard\n              remainingBillableUtilizationTaskAndAllocationsCombinedHard\n              remainingNonBillableUtilizationTaskAndAllocationsCombinedHard\n              remainingResourceUtilizationTaskAndAllocationsCombinedHard\n              forecastBillableTaskAndAllocationsCombinedWin\n              forecastNonBillableTaskAndAllocationsCombinedWin\n              forecastTotalTimeTaskAndAllocationsCombinedWin\n              forecastBillableUtilizationTaskAndAllocationsCombinedWin\n              forecastNonBillableUtilizationTaskAndAllocationsCombinedWin\n              forecastResourceUtilizationTaskAndAllocationsCombinedWin\n              forecastBillableTaskAndAllocationsCombinedSoft\n              forecastNonBillableTaskAndAllocationsCombinedSoft\n              forecastTotalTimeTaskAndAllocationsCombinedSoft\n              forecastBillableUtilizationTaskAndAllocationsCombinedSoft\n              forecastNonBillableUtilizationTaskAndAllocationsCombinedSoft\n              forecastResourceUtilizationTaskAndAllocationsCombinedSoft\n              forecastBillableTaskAndAllocationsCombinedSoftWin\n              forecastNonBillableTaskAndAllocationsCombinedSoftWin\n              forecastTotalTimeTaskAndAllocationsCombinedSoftWin\n              forecastBillableUtilizationTaskAndAllocationsCombinedSoftWin\n              forecastNonBillableUtilizationTaskAndAllocationsCombinedSoftWin\n              forecastResourceUtilizationTaskAndAllocationsCombinedSoftWin\n              forecastBillableTaskAndAllocationsCombinedHard\n              forecastNonBillableTaskAndAllocationsCombinedHard\n              forecastTotalTimeTaskAndAllocationsCombinedHard\n              forecastBillableUtilizationTaskAndAllocationsCombinedHard\n              forecastNonBillableUtilizationTaskAndAllocationsCombinedHard\n              forecastResourceUtilizationTaskAndAllocationsCombinedHard\n              billableActualVsPlan\n              billableActualVsPlanWin\n              billableActualVsPlanSoft\n              billableActualVsPlanSoftWin\n              billableActualVsPlanHard\n              nonBillableActualVsPlan\n              nonBillableActualVsPlanWin\n              nonBillableActualVsPlanSoft\n              nonBillableActualVsPlanSoftWin\n              nonBillableActualVsPlanHard\n              internalActualVsPlan\n              totalActualVsPlan\n              totalActualVsPlanWin\n              totalActualVsPlanSoft\n              totalActualVsPlanSoftWin\n              totalActualVsPlanHard\n              remainingBillableProjectMinutes\n              remainingBillableProjectMinutesWin\n              remainingBillableProjectMinutesSoft\n              remainingBillableProjectMinutesSoftWin\n              remainingBillableProjectMinutesHard\n              remainingNonBillableProjectMinutes\n              remainingNonBillableProjectMinutesWin\n              remainingNonBillableProjectMinutesSoft\n              remainingNonBillableProjectMinutesSoftWin\n              remainingNonBillableProjectMinutesHard\n              remainingInternalMinutes\n              remainingTotalMinutes\n              remainingTotalMinutesWin\n              remainingTotalMinutesSoft\n              remainingTotalMinutesSoftWin\n              remainingTotalMinutesHard\n              remainingBillableUtilization\n              remainingBillableUtilizationWin\n              remainingBillableUtilizationSoft\n              remainingBillableUtilizationSoftWin\n              remainingBillableUtilizationHard\n              remainingNonBillableUtilization\n              remainingNonBillableUtilizationWin\n              remainingNonBillableUtilizationSoft\n              remainingNonBillableUtilizationSoftWin\n              remainingNonBillableUtilizationHard\n              remainingInternalUtilization\n              remainingResourceUtilization\n              remainingResourceUtilizationWin\n              remainingResourceUtilizationSoft\n              remainingResourceUtilizationSoftWin\n              remainingResourceUtilizationHard\n              remainingBillableTaskAndAllocationsCombined\n              remainingNonBillableTaskAndAllocationsCombined\n              remainingInternalTimeTaskAndAllocationsCombined\n              remainingTotalTimeTaskAndAllocationsCombined\n              remainingBillableUtilizationTaskAndAllocationsCombined\n              remainingInternalUtilizationTaskAndAllocationsCombined\n              remainingResourceUtilizationTaskAndAllocationsCombined\n              forecastBillableProjectMinutes\n              forecastBillableProjectMinutesWin\n              forecastBillableProjectMinutesSoft\n              forecastBillableProjectMinutesSoftWin\n              forecastBillableProjectMinutesHard\n              forecastNonBillableProjectMinutes\n              forecastNonBillableProjectMinutesWin\n              forecastNonBillableProjectMinutesSoft\n              forecastNonBillableProjectMinutesSoftWin\n              forecastNonBillableProjectMinutesHard\n              forecastInternalMinutes\n              forecastTotalMinutes\n              forecastTotalMinutesWin\n              forecastTotalMinutesSoft\n              forecastTotalMinutesSoftWin\n              forecastTotalMinutesHard\n              forecastBillableUtilization\n              forecastBillableUtilizationWin\n              forecastBillableUtilizationSoft\n              forecastBillableUtilizationSoftWin\n              forecastBillableUtilizationHard\n              forecastNonBillableUtilization\n              forecastNonBillableUtilizationWin\n              forecastNonBillableUtilizationSoft\n              forecastNonBillableUtilizationSoftWin\n              forecastNonBillableUtilizationHard\n              forecastInternalUtilization\n              forecastResourceUtilization\n              forecastResourceUtilizationWin\n              forecastResourceUtilizationSoft\n              forecastResourceUtilizationSoftWin\n              forecastResourceUtilizationHard\n              forecastBillableTaskAndAllocationsCombined\n              forecastNonBillableTaskAndAllocationsCombined\n              forecastInternalTimeTaskAndAllocationsCombined\n              forecastTotalTimeTaskAndAllocationsCombined\n              forecastBillableUtilizationTaskAndAllocationsCombined\n              forecastNonBillableUtilizationTaskAndAllocationsCombined\n              forecastInternalUtilizationTaskAndAllocationsCombined\n              forecastResourceUtilizationTaskAndAllocationsCombined\n              tasksEstimateBillableMinutes\n              tasksEstimateNonBillableMinutes\n              tasksEstimateTotalMinutes\n              tasksBillableUtilization\n              tasksNonBillableUtilization\n              tasksResourceUtilization\n              tasksRemainingBillableMinutes\n              tasksRemainingNonBillableMinutes\n              tasksRemainingTotalMinutes\n              tasksRemainingBillableUtilization\n              tasksRemainingNonBillableUtilization\n              tasksRemainingResourceUtilization\n              tasksOverdueRemainingBillableMinutes\n              tasksOverdueRemainingNonBillableMinutes\n              tasksOverdueRemainingTotalMinutes\n              tasksForecastBillableMinutes\n              tasksForecastNonBillableMinutes\n              tasksForecastTotalMinutes\n              tasksForecastBillableUtilization\n              tasksForecastNonBillableUtilization\n              tasksForecastResourceUtilization\n              tasksBillableActualVsPlan\n              tasksNonBillableActualVsPlan\n              tasksTotalActualVsPlan\n              plannedBillableAllocationVsTask\n              plannedBillableAllocationVsTaskWin\n              plannedBillableAllocationVsTaskSoft\n              plannedBillableAllocationVsTaskSoftWin\n              plannedBillableAllocationVsTaskHard\n              plannedNonBillableAllocationVsTask\n              plannedNonBillableAllocationVsTaskWin\n              plannedNonBillableAllocationVsTaskSoft\n              plannedNonBillableAllocationVsTaskSoftWin\n              plannedNonBillableAllocationVsTaskHard\n              plannedAllocationVsTask\n              plannedAllocationVsTaskWin\n              plannedAllocationVsTaskSoft\n              plannedAllocationVsTaskSoftWin\n              plannedAllocationVsTaskHard\n              remainingBillableAllocationVsTask\n              remainingBillableAllocationVsTaskWin\n              remainingBillableAllocationVsTaskSoft\n              remainingBillableAllocationVsTaskSoftWin\n              remainingBillableAllocationVsTaskHard\n              remainingNonBillableAllocationVsTask\n              remainingNonBillableAllocationVsTaskWin\n              remainingNonBillableAllocationVsTaskSoft\n              remainingNonBillableAllocationVsTaskSoftWin\n              remainingNonBillableAllocationVsTaskHard\n              remainingAllocationVsTask\n              remainingAllocationVsTaskWin\n              remainingAllocationVsTaskSoft\n              remainingAllocationVsTaskSoftWin\n              remainingAllocationVsTaskHard\n              timeOffMinutes\n            }\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n    id\n  }\n  projectGroups(first: 100000) {\n    edges {\n      node {\n        id\n        companyProjectGroupId\n        name\n        color\n        readOnlyAccess\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "21e3e48e7d0f6f5b0f545b0b4463662c";

export default node;
